// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1140":"4eb46806","4675":"0f4e2cb6","5416":"865b56d6","6625":"031f89d5","7146":"31d6cfe0","7680":"4eb46806","7712":"4da8027f","8151":"4da8027f"}[chunkId] + ".chunk.css";
};